export default __webpack_public_path__ + "static/media/mar2024-1.c86a46ef.jpg";